exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-form .rc-color-picker-wrap {\n  width: 20%; }\n  .ant-form .rc-color-picker-wrap .ant-input {\n    height: 30px; }\n\n.ant-form .ant-form-item {\n  display: block;\n  margin-bottom: 10px; }\n\n.ant-form > .ant-form-item:first-of-type {\n  margin-top: 0; }\n\n.ant-form .ant-form-item-label {\n  line-height: 28px; }\n\n.ant-form .ant-form-item-label, .ant-form .ant-checkbox-wrapper {\n  font-weight: 500; }\n\n.ant-form .buttons-group {\n  width: 100%;\n  border-top: 1px solid #e8e8e8;\n  margin-top: 10px;\n  padding-top: 20px;\n  text-align: right;\n  border-radius: 0 0 4px 4px; }\n  .ant-form .buttons-group button {\n    margin-left: 10px; }\n\n.ant-form-advanced .ant-form-item-label {\n  text-align: left;\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./src/components/Form/styles.scss
// module id = ../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./src/components/Form/styles.scss
// module chunks = 0